export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        // badge: {
        //   color: 'primary',
        //   text: 'NEW'
        // }
      },

      {
        _name: 'CSidebarNavItem',
        name: 'Users',
        to: '/users',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Business',
        to: '/businesses',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Customers',
        to: '/customers',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Entries',
        to: '/entries',
        icon: 'cil-calculator'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Cashes',
        to: '/cash',
        icon: 'cil-dollar'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Transaction View Log',
        to: '/transactionviewlog',
        icon: 'cil-dollar'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Settings',
        to: '/setting',
        icon: 'cil-settings'
      },
    
    ]
  }
]